import { Breadcrumb, Button } from "pepsico-ds";
import { paths } from "../../../routes/paths";
import "./keywordManagement.scss";
import KeywordModal from "./KeywordModal";
import KeywordsTable from "./KeywordsTable";
import ToastNotification from "../../../components/common/toastNotification/ToastNotification";
import { useKeywordModal } from "../../../hooks/useKeywordModal";
import { useKeywords } from "../../../hooks/useKeywords";

export default function KeywordManagementPage() {
  const { keywords, loading, searchTerm, handlers, refetch } = useKeywords();
  const { handleSearch, handleSearchChange } = handlers;

  const {
    isOpen,
    mode,
    formData,
    formErrors,
    isLoading: modalLoading,
    openModal,
    closeModal,
    handleFormChange,
    handleSubmit,
    toast,
    closeToast,
  } = useKeywordModal();

  const handleAddKeyword = () => {
    openModal("add", {});
  };

  const handleEdit = (keyword) => {
    openModal("edit", keyword);
  };

  const handleDelete = (id, name) => {
    openModal("delete", { id, name });
  };

  const handleModalSubmit = async () => {
    const result = await handleSubmit(() => {
      if (refetch) {
        refetch();
      }
    });
    return result;
  };

  return (
    <div className="container">
      <div className="wrap">
        <Breadcrumb
          breadcrumbs={[
            {
              label: "System Setting",
              href: `../../../${paths.system_setting}`,
            },
            {
              label: "Keyword Management",
              href: `../../../${paths.system_setting}/keyword-management`,
            },
          ]}
          activeIndex={1}
        />
        <div className="keyword-management-container">
          <div className="page-header">
            <h3 className="page-title">Keywords Management</h3>
            <Button
              text="Add Keyword"
              variant="primary"
              onClick={handleAddKeyword}
              className="add-keyword-btn"
            />
          </div>
          <KeywordsTable
            keywords={keywords}
            loading={loading}
            searchTerm={searchTerm}
            handleEdit={handleEdit}
            handleSoftDelete={handleDelete}
            handleSearch={handleSearch}
            handleSearchChange={handleSearchChange}
          />
        </div>
        <KeywordModal
          isOpen={isOpen}
          mode={mode}
          formData={formData}
          formErrors={formErrors}
          isLoading={modalLoading}
          onClose={closeModal}
          onSubmit={handleModalSubmit}
          onFormChange={handleFormChange}
        />
        <ToastNotification
          {...toast}
          handleClose={closeToast}
          sx={{ zIndex: 9999 }}
        />
      </div>
    </div>
  );
}
